// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TOz8","questions":"styles_questions__2FipY","footer":"styles_footer__2wZFp"};